import { useEffect, useState } from "react";
import Lenis from "lenis";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import LandingPage from "@/components/landing/LandingPage";
import BookingDialog from "@/components/landing/BookingDialog";

function App() {
  const [booking, setBooking] = useState({ open: false, service: "New website" });

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, duration: 1.2, smoothWheel: true });
    let frameId;

    const raf = (time) => {
      lenis.raf(time);
      frameId = requestAnimationFrame(raf);
    };

    frameId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frameId);
      lenis.destroy();
    };
  }, []);

  const openBooking = (service = "New website") => setBooking({ open: true, service });

  return (
    <div className="App bg-[#08080C] text-slate-100 antialiased">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage openBooking={openBooking} />} />
        </Routes>
        <BookingDialog
          open={booking.open}
          service={booking.service}
          onOpenChange={(open) => setBooking((current) => ({ ...current, open }))}
        />
        <Toaster theme="dark" position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
